import React, { useState } from 'react';
import { Policy } from '../../../types';
import { addPolicy, fetchPolicies, updatePolicy } from '../../../features/admin/policySlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';


type Props = {
    initialData: Policy | null;
    onClose: () => void;
    onSuccess: () => void;
};

const PolicyModal = ({ initialData, onClose, onSuccess }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()
    const [formData, setFormData] = useState<{
        id?: number;
        details: string;
        detailsAr: string;
        link: string;
    }>({
        id: initialData?.id,
        details: initialData?.details || '',
        detailsAr: initialData?.detailsAr || '',
        link: initialData?.link || ''
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (formData.details.length < 10 || formData.detailsAr.length < 10) {
            toast.error(t("policy-details-error"));
            return
        }

        if (initialData) {
            initialData.id && dispatch(updatePolicy({ id: initialData.id, Data: formData }))
        } else {
            dispatch(addPolicy(formData));

        }
        await dispatch(fetchPolicies());
        onSuccess();
        onClose();
    };

    return (
        <div className="fixed inset-0 p-5 bg-black bg-opacity-30 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg space-y-4">
                <h2 className="text-xl font-bold text-center">
                    {initialData ? t("modal-title-edit") : t("modal-title-create")}
                </h2>
                <textarea
                    name="details"
                    value={formData.details}
                    onChange={handleChange}
                    placeholder={t("details-placeholder")}
                    className="w-full border rounded px-3 py-2 h-28"
                />
                <textarea
                    name="detailsAr"
                    value={formData.detailsAr}
                    onChange={handleChange}
                    placeholder={t("detailsAr-placeholder")}
                    className="w-full border rounded px-3 py-2 h-28"
                />
                <input
                    name="link"
                    value={formData.link}
                    onChange={handleChange}
                    placeholder={t("link-placeholder")}
                    className="w-full border rounded px-3 py-2"
                />
                <div className="flex justify-between pt-4">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">
                        {t("cancel")}
                    </button>
                    <button onClick={handleSubmit} className="px-4 py-2 bg-primary text-white rounded">
                        {initialData ? t("update") : t("create")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PolicyModal;
